import * as React from 'react'

function LogoWohPag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={'100%'}
      height={'100%'}
      viewBox='0 0 192 68'
      {...props}
    >
      <path
        fill='#942692'
        d='m7 6 16.563-.25 5.185-.11c1.377-.012 2.754-.022 4.13-.03l2.117-.063c6.236-.004 10.501 1.954 14.92 6.363C52.04 16.002 51.502 20.523 51 25c-1.375 3.188-1.375 3.188-3 5h-2v2l2.313.688C51.773 34.377 52.578 35.41 54 39c.686 5.011.552 8.832-1.625 13.438C48.529 56.587 44.489 58.145 39 59c-2.495.08-4.992.108-7.488.098l-3.9-.008-4.924-.028L7 59V6Zm10 8v14c2.375.054 4.75.094 7.125.125.665.017 1.33.034 2.016.05 5.24.052 9.815-.387 13.859-3.925 1.288-2.33 1.288-2.33.438-5.375C38.828 15.659 38.242 15.238 35 14c-2.122-.272-2.122-.272-4.328-.195l-2.422.02-2.5.05-2.547.027c-2.068.024-4.135.06-6.203.098Zm0 22v14c3.417.054 6.833.094 10.25.125l2.934.05 2.832.02 2.602.032c2.6-.248 4.187-.832 6.382-2.227 1.4-2.799 1.253-4.905 1-8-1.853-2.56-2.938-2.98-6-4a79.866 79.866 0 0 0-4.668-.098l-2.705.01-2.814.026-2.85.013c-2.321.012-4.642.03-6.963.049Z'
      />
      <path
        fill='#922690'
        d='M91.5 19.563c4.85 2.87 7.742 7.164 9.5 12.437v10l-30 1c4.184 5.35 4.184 5.35 9.91 6.855 4.741.328 9.026-1.58 13.09-3.855l5 7c-6.689 5.733-11.87 6.463-20.55 6.309-6.62-.593-10.497-2.996-14.888-7.871C58.88 45.707 59.413 39.087 60 32c1.497-5.67 4.485-8.915 9.316-12.09 6.303-3.407 15.704-3.247 22.184-.348ZM73 28c-2.345 3.214-2.345 3.214-3 7h21c-1.055-4.22-1.853-5.234-5-8-4.102-2.051-9.316-1.763-13 1Z'
      />
      <path
        fill='#932591'
        d='M147 18h34c0 8.997 0 8.997-2.598 11.746l-1.67 1.836-1.794 1.855c-1.195 1.301-2.388 2.603-3.579 3.907l-1.752 1.886c-3.1 3.414-5.832 7.092-8.607 10.77l21 1v8h-36c0-7.872 0-7.872 2.344-10.395l1.518-1.692 1.638-1.725c1.102-1.218 2.202-2.437 3.3-3.657l1.648-1.8c2.862-3.191 5.474-6.572 8.126-9.938C166 28 166 28 167 27l-20-1v-8Z'
      />
      <path
        fill='#932491'
        d='M107 18h34c0 8.997 0 8.997-2.598 11.746l-1.67 1.836-1.794 1.855c-1.195 1.301-2.388 2.603-3.579 3.907l-1.752 1.886c-3.1 3.414-5.832 7.092-8.607 10.77l21 1v8h-36c0-7.872 0-7.872 2.344-10.395l1.518-1.692 1.638-1.725c1.102-1.218 2.202-2.437 3.3-3.657l1.648-1.8c2.862-3.191 5.474-6.572 8.126-9.938C126 28 126 28 127 27l-20-1v-8Z'
      />
      <path fill='#8C2B88' d='m45 30 1 2a78.037 78.037 0 0 0 5 2l-1 2h-6l1-6Z' />
    </svg>
  )
}

export default LogoWohPag
